import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from '../../Services/storage.service';
import {DataService} from '../../Services/data.service';
import {BsToastService} from '../../Services/bs-toast-service';

@Component({
  selector: 'app-delinquent-receivables',
  templateUrl: './delinquent-receivables.component.html',
  styleUrls: ['./delinquent-receivables.component.css'],
  standalone: false
})
export class DelinquentReceivablesComponent implements OnInit {

  permissions: any = {};
  isLoading = false;

  delinquentList: any[] = [];
  minDaysOverdue = 1;
  page = 0;
  pageSize = 25;
  totalRecords = 0;

  // Log Interaction modal state
  showLogInteraction = false;
  activeEntityId = '';
  activeEntityName = '';
  newInteraction: any = {
    interaction_type: 'call',
    subject: '',
    body: '',
    outcome: 'neutral',
    follow_up_required: false
  };

  // Schedule Event modal state
  showScheduleEvent = false;
  newEvent: any = {title: '', description: '', start: '', allDay: false};

  constructor(
    private localStorage: StorageService,
    private dataService: DataService,
    private notification: BsToastService,
    private router: Router
  ) {
    this.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));
  }

  ngOnInit(): void {
    if (this.permissions.Admin || this.permissions.ReceivableAging) {
      this.load();
    }
  }

  private companyParam(prefix = '?'): string {
    const id = this.localStorage.StorageGet('default_company_id', '');
    return id ? prefix + 'company_id=' + encodeURIComponent(id) : '';
  }

  get totalPages(): number {
    return Math.ceil(this.totalRecords / this.pageSize) || 1;
  }

  get pageEnd(): number {
    return Math.min((this.page + 1) * this.pageSize, this.totalRecords);
  }

  prevPage(): void {
    if (this.page > 0) {
      this.page--;
      this.load();
    }
  }

  nextPage(): void {
    if ((this.page + 1) < this.totalPages) {
      this.page++;
      this.load();
    }
  }

  load(): void {
    this.isLoading = true;
    const cp = this.companyParam('&');
    const url = 'crm/ar/delinquent?minDaysOverdue=' + this.minDaysOverdue
      + '&sortBy=lastInteractionDate&sortDir=asc&sortBy2=entityName'
      + '&page=' + this.page + '&pageSize=' + this.pageSize + cp;
    this.dataService.getData(url).subscribe({
      next: (result: any) => {
        console.log('Collections Worklist result:', result);
        this.delinquentList = result?.items ?? result ?? [];
        this.totalRecords = result?.total ?? this.delinquentList.length;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  openLogInteraction(entity: any): void {
    this.activeEntityId = entity.entityId ?? entity.id ?? '';
    this.activeEntityName = entity.entityName ?? entity.name ?? '';
    this.newInteraction = {interaction_type: 'call', subject: '', body: '', outcome: 'neutral', follow_up_required: false};
    this.showLogInteraction = true;
  }

  submitInteraction(): void {
    this.dataService.post('crm/entities/' + this.activeEntityId + '/interactions', this.newInteraction).subscribe({
      next: () => {
        this.notification.showSuccessToast('Interaction logged.');
        this.showLogInteraction = false;
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Failed to log interaction.');
      }
    });
  }

  openScheduleEvent(entity: any): void {
    this.activeEntityId = entity.entityId ?? entity.id ?? '';
    this.activeEntityName = entity.entityName ?? entity.name ?? '';
    this.newEvent = {title: '', description: '', start: '', allDay: false};
    this.showScheduleEvent = true;
  }

  submitEvent(): void {
    this.dataService.post('crm/entities/' + this.activeEntityId + '/events', this.newEvent).subscribe({
      next: () => {
        this.notification.showSuccessToast('Follow-up scheduled.');
        this.showScheduleEvent = false;
      },
      error: () => {
        this.notification.showErrorToast('Failed to schedule event.');
      }
    });
  }

  viewCrmRecord(entity: any): void {
    const id = entity.entityId ?? entity.id ?? '';
    this.router.navigate(['/crm/entities', id]);
  }

  onMinDaysChange(): void {
    this.page = 0;
    this.load();
  }
}
